<template>
  <div style="display: flex;width: 100%;height: 210px;" class="contain">
    <canvas style="width: 8%;" id="yCanvas" width="30" height="180"></canvas>
    <div style="display: flex; flex-direction: column; width: 90%">
      <canvas style="height: 100%" id="spectrumCanvas" width="400" height="180"></canvas>
      <canvas id="xCanvas" width="400" height="30"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gain: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      maxValue: 80,
    };
  },
  mounted() {
    //     let canvas = document.getElementById('canvas');
    // let ctx = canvas.getContext('2d');
    // // 设置背景透明
    // ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    // ctx.strokeStyle = 'white';
    // // ctx.strokeRect(0, 0, canvas.width, canvas.height);
    // // 绘制刻度线和刻度值
    // const startX = 0;
    // const endX = canvas.width ;
    // const stepX = 10;
    // for (let i = startX; i <= endX; i += stepX) {
    //   if (i % 50 === 0) { // 每 50 个像素画一个长线
    //     ctx.beginPath();
    //     ctx.moveTo(i, 30);
    //     ctx.lineTo(i, 50);
    //     ctx.stroke();
    //     // 绘制刻度值
    //     ctx.fillStyle = 'white';
    //     ctx.fillText(i / 0.1, i , 70);
    //   } else { // 其他情况画短线
    //     ctx.beginPath();
    //     ctx.moveTo(i, 40);
    //     ctx.lineTo(i, 50);
    //     ctx.stroke();
    //   }
    // }
    // // 绘制刻度尺
    // ctx.font = 'bold 12px Arial';
    // ctx.fillStyle = 'white';
    // // ctx.textAlign = 'top';
    // // ctx.fillText('0Hz', startX , 70);
    // ctx.fillText('Hz', endX - 25, 70);
  },
  methods: {
    drawSpectrum(analyser) {
      // console.log(analyser);
      //导入正在播放的waveSurfer的analyser
      //this.$refs.player.waveSurfer.backend.analyser
      let canvas = document.getElementById("spectrumCanvas"),
        animationId = null,
        cwidth = canvas.width,
        cheight = canvas.height - 2,
        meterWidth = 10, //width of the meters in the spectrum
        gap = 2, //gap between meters
        capHeight = 2,
        capStyle = "#fff",
        meterNum = 2300 / (10 + 2), //count of the meters
        capYPositionArray = []; ////store the vertical position of hte caps for the preivous frame
      let ctx = canvas.getContext("2d");
      let gradient = ctx.createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(1, "#8bc34a"); // 定义颜色断点1（100%）
      gradient.addColorStop(0.5, "#4caf50"); // 定义颜色断点2（50%）
      gradient.addColorStop(0, "#009688"); // 定义颜色断点3（0%）
      // gradient.addColorStop(1, '#00ffff'); // 定义颜色断点1（100%）
      // gradient.addColorStop(0.5, '#ff00ff'); // 定义颜色断点2（50%）
      // gradient.addColorStop(0, '#ff0000'); // 定义颜色断点3（0%）

      //ctxX画横坐标.
      let canvas2 = document.getElementById("xCanvas");
      let ctxX = canvas2.getContext("2d");
      ctxX.fillStyle = "gray";
      ctxX.strokeStyle = "#d5f2ff78";
      ctxX.beginPath();
      ctxX.moveTo(0, 10);
      ctxX.lineTo(400, 10);
      ctxX.stroke();
      ctxX.font = "12px Arial";
      ctxX.textAlign = "center";
      ctxX.textBaseline = "top";
      for (let i = 0; i < 9; i++) {
        ctxX.fillText(i * 500, i * 45 + 10, 15);
      }
      ctxX.fillText("Hz", 392, 15);


        //画纵坐标
        let canvasY = document.getElementById("yCanvas");
        let ctxY = canvasY.getContext("2d");
        //ctxY画纵坐标之前先清除掉之前的
        ctxY.clearRect(0, 0, 30, 180);
        //ctxY画纵坐标.
        ctxY.fillStyle = "gray";
        ctxY.font = "12px Arial";
        ctxY.textAlign = "center";
        ctxY.textBaseline = "top";
        // for (let i = 0; i < 8; i++) {
        //     ctxY.fillText(
        //         i * Math.floor(this.maxValue / 8),
        //         15,
        //         180 - i * 20 - 25
        //     );
        // }
        ctxY.fillText("dB", 15, 0);
        // ctxY.fillText("0", 15, 30 + 150);


        ctxY.fillText("0", 15, 180 - Math.pow(10,0/20)*138);
        ctxY.fillText("-1", 15, 180 - Math.pow(10,-1/20)*138);
        ctxY.fillText("-5", 15, 180 - Math.pow(10,-5/20)*138);
        ctxY.fillText("-10", 15, 180 - Math.pow(10,-10/20)*138);
        // ctxY.fillText("-5", 15, 40);
        // ctxY.fillText("-10", 15, 40);

      
      let drawMeter = () => {
        let array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        let step = Math.round(array.length / meterNum); //sample limited data from the total array
        ctx.clearRect(0, 0, cwidth, cheight);


        // //找出数组array中的最大值
        // for (let i = 0; i < array.length; i++) {
        //   if (array[i] > this.maxValue) {
        //     this.maxValue = array[i];
        //   }
        // }


        for (let i = 0; i < meterNum; i++) {
          let value = array[i * step] * 0.5;
          //   let value = 255*0.5;
          if (capYPositionArray.length < Math.round(meterNum)) {
            capYPositionArray.push(value);
          }
          ctx.fillStyle = capStyle;
          //draw the cap, with transition effect
          if (value < capYPositionArray[i]) {
            ctx.fillRect(
              i * 12,
              cheight - --capYPositionArray[i],
              meterWidth,
              capHeight
            );
          } else {
            ctx.fillRect(i * 12, cheight - value, meterWidth, capHeight);
            capYPositionArray[i] = value;
          }
          ctx.fillStyle = gradient; //set the filllStyle to gradient for a better look
          ctx.fillRect(
            i * 12 /*meterWidth+gap*/,
            cheight - value + capHeight,
            meterWidth,
            cheight
          ); //the meter
        }
        animationId = requestAnimationFrame(drawMeter);
      };
      animationId = requestAnimationFrame(drawMeter);
    },
  },
};
</script>

<style scoped>
.contain {
  background-color: var(--audio-bg);
}
</style>


// WEBPACK FOOTER //
// src/pages/home/realTime/dynamic-spectrum.vue